import { withPending, withRejected, withFulFilled } from './commons';
import { FETCH_SURVEYS_BY_TENANT } from '../actions/surveys';

// initial state
const INITIAL_STATE = {
  running: false,
  error: null,
  payload: [/* {id: number, titulo: string} */],
};

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  // surveys
  case withPending(FETCH_SURVEYS_BY_TENANT):
    return { ...state, running: true };
  case withRejected(FETCH_SURVEYS_BY_TENANT):
    return { ...state, running: false, error: action.payload };
  case withFulFilled(FETCH_SURVEYS_BY_TENANT):
    return { ...state, running: false, payload: [...action.payload.data] };
    // nothing
  default:
    return state;
  }
};

export default execute;
